import sendEvent from '../sendEvent';

jQuery(function ($) {
	const $dataElement = $('#DataElement');

	const $crTitle = $dataElement.attr('data-cr-title');
	const $yearLevel = $dataElement.attr('data-yearlevel');
	const $kla = $dataElement.attr('data-kla');
	const $noOfLessons = $dataElement.attr('data-no-of-lessons');
	const $duration = $dataElement.attr('data-duration');

	sendEvent({
		type: 'EDU-interaction',
		CR_title: $crTitle,
		Year_level: $yearLevel,
		KLA: $kla,
		No_of_lessons: $noOfLessons,
		Duration: $duration,
		Page_URL: window.location.toString(),
		Button_Location: 'Click - content',
	});

	$('[data-button-label]').on('click', function () {
		sendEvent({
			type: 'EDU-buttonClick',
			CR_title: $crTitle,
			Year_level: $yearLevel,
			KLA: $kla,
			No_of_lessons: $noOfLessons,
			Duration: $duration,
			Button_Label: $(this).attr('data-button-label'),
			Lessons: $(this).attr('data-lesson') ?? null,
			Page_URL: window.location.toString(),
			Button_Location: 'Click - ' + $(this).attr('data-button-location'),
		});
	});

	$('[data-slide-nav]').on('click', function () {
		sendEvent({
			type: 'EDU-click',
			clickLabel: $(this).attr('data-slide-nav'),
			clickLocation: 'EDU Page',
			CR_title: $crTitle,
			Year_level: $yearLevel,
			KLA: $kla,
			No_of_lessons: $noOfLessons,
			Duration: $duration,
			Button_Label: $(this).attr('data-slide-nav'),
			Lessons: $(this).attr('data-slide-nav') ?? null,
			Page_URL: window.location.toString(),
			Button_Location: 'Click - ' + $(this).attr('data-slide-nav'),
		});
	});

	console.log('loaded');

	$('.lessonSlideNavigator__title').each(function () {
		const $words = $(this).text().split(' ');
		if ($words.length > 2) {
			const wrappedSentence =
				$words[0] + '<br />' + $words.slice(1).join(' ');
			$(this).html(wrappedSentence);
		}
	});
});
